import { render, staticRenderFns } from "./chainBasicInfo copy.vue?vue&type=template&id=56eeb1ee&scoped=true&"
import script from "./chainBasicInfo copy.vue?vue&type=script&lang=js&"
export * from "./chainBasicInfo copy.vue?vue&type=script&lang=js&"
import style0 from "./chainBasicInfo copy.vue?vue&type=style&index=0&id=56eeb1ee&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eeb1ee",
  null
  
)

export default component.exports